// import { Select,Portal  } from "@chakra-ui/react"
import { Portal, Select, createListCollection } from "@chakra-ui/react"
import { useEffect,useState } from "react";


export default function SelectC(props) {
  const { label,placeholder,items,enableLabel,selectedValue } = props;
  const frameworks = createListCollection({ items: items });
  const [selected, setSelected] = useState(items[0]);

  return (
    <Select.Root collection={frameworks} size={props.size ||"sm"} {...props} color={"var(--crt-3)"}>
      <Select.HiddenSelect />
      {enableLabel !== false && <Select.Label>{label}</Select.Label>}
      <Select.Control>
        <Select.Trigger
            fontSize={props.fontSize||"sm"}
            _placeholder={{fontSize: props.fontSize || "sm" }}
            placeholder={placeholder || label}
            borderRadius="sm"
            bg="#fbfdfeff"
            borderColor= {props.borderColor || "#cfdddfff"}
            _dark={{ bg: "#f5faffff" }}
            _hover={{ bg: "#f5faffff", _dark: { bg: "#f5faffff" } }}
            _focusVisible={{
              borderColor: "#bcf4ffff",
              boxShadow: "#1E93AB 0px 0px 2px 0px",
            }}
        >
          <Select.ValueText placeholder={placeholder}>{selectedValue}</Select.ValueText>
        </Select.Trigger>
        <Select.IndicatorGroup>
          <Select.Indicator />
        </Select.IndicatorGroup>
      </Select.Control>
      <Portal>
        <Select.Positioner>
          <Select.Content>
            {items.map((framework) => (
              <Select.Item fontSize={props.fontSize || "sm"} item={framework} key={framework.value}>
                {framework.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>

  )
}


